import FingerPrint from "fingerprintjs2";
import Cookies from "js-cookie";
import PageLifecycle from "page-lifecycle/dist/lifecycle.es5";

import { TrackingApi } from "../api/Api";

const TIMEOUT = 1800; // 30 minutes
let skipArticleViewEnd = false,
    scrollPercentage = 0,
    articleScrollPercentage = 0;


export default {
    setTrackingCookie(cb = () => {}) {
        if(Cookies.get("_wfp")) {
            cb();
        } else {
            // Compute a fingerprint based on user browser settings and put it in a cookie
            new FingerPrint({
                excludeColorDepth: true,
                excludeDoNotTrack: true,
                excludeAdBlock: true,
                excludePlugins: true,
                excludeIEPlugins: true
            }).get( fingerPrint => {
                Cookies.set("_wfp", fingerPrint, { expires: 365 });
                cb();
            });
        }
    },

    _getArticleViewStartTime() {
        return performance && performance.now ? performance.now() : 0;
    },

    _getArticleViewDuration() {
        if(performance && performance.now) {
            // Set article view duration to 1H max to avoid bad data
            let articleViewDuration = ((performance.now() - this.articleViewStartTime) / 1000).toFixed(2);
            if(articleViewDuration > TIMEOUT) {
                return TIMEOUT;
            } else {
                return articleViewDuration;
            }
        } else {
            return 0;
        }
    },

    stopArticleViewTracking() {
        if(skipArticleViewEnd) {
            return;
        } else {
            skipArticleViewEnd = true;
        }

        // Compute article view duration and convert it into seconds
        let articleViewDuration = this._getArticleViewDuration();

        let data = {
            contentId: $("meta[itemprop='identifier']").attr("content"),
            title: document.title
        };

        if(scrollPercentage) {
            data.scrollPercentage = scrollPercentage;
        }
        if(articleScrollPercentage) {
            data.articleScrollPercentage = articleScrollPercentage;
        }

        // Send article view duration if browser support it
        if(articleViewDuration > 0) {
            data.articleViewDuration = articleViewDuration;
        }

        dataLayer.forEach(o => {
            if(o.edition) data.editionId = o.edition;
            if(o.section) data.sectionId = o.section;
            if(o.author_id) data.authorId = o.author_id;
        });

        this.track("view.article.end", data);
    },

    startArticleViewTracking() {
        this.articleViewStartTime = this._getArticleViewStartTime();

        // page-lifecycle is a cross-browser library which is helping us to determine if user has close the page/tab/browser
        PageLifecycle.addEventListener("statechange", (event) => {
            if(event.newState === "terminated" || event.newState === "hidden") {
                this.stopArticleViewTracking();
            }
        });

        // Compute scroll amount percentage and keep highest value in memory
        const articlePageContent = $(".article-page-content");
        window.addEventListener('scroll', () => {
            let currentScrollPercentage = Math.ceil( ($(document).scrollTop() / ($(document).height() - $(window).height())) * 100),
                currentArticleScrollPercentage = Math.ceil( ($(document).scrollTop() / (articlePageContent.offset().top + articlePageContent.innerHeight() - $(window).height())) * 100);
            if(currentScrollPercentage > scrollPercentage) {
                scrollPercentage = currentScrollPercentage < 100 ? currentScrollPercentage : 100;
            }
            if(currentArticleScrollPercentage > articleScrollPercentage) {
                articleScrollPercentage = currentArticleScrollPercentage < 100 ? currentArticleScrollPercentage : 100;
            }
        });
    },

    trackAnnouncement(announcementId, type, isContentAccessible, isPaid) {
        let data = {
            announcementId: announcementId,
            announcementType: type,
            isPaid: isPaid,
            isContentAccessible: isContentAccessible
        };
        dataLayer.forEach(o => {
            if(o.edition) data.editionId = o.edition;
        });
        this.track("view.announcement", data);
    },

    /**
     * Call tracking event API
     * It'll always set a fingerprint cookie first to avoid calling the API without fingerprint
     * @param action: event action
     * @param data: @Object event data
     */
    track(action, data) {
        this.setTrackingCookie(() => TrackingApi.track(action, data) );
    }
}



// WEBPACK FOOTER //
// ./js/analytics/Tracking.js